import {
    SWITCHER_CHANGE
} from '../actions/relativesSwitcher';

const initialState = {
    activeIndex: 0
};

export default function relativesSwitcher(state = initialState, action) {
    switch (action.type) {
        case SWITCHER_CHANGE:
            return Object.assign({}, state, {
                activeIndex: action.index
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/relativesSwitcher.js